import React, { memo } from 'react';
import picture_in_picture_alt from 'assets/icons/picture_in_picture_alt.svg';
import picture_in_picture from 'assets/icons/picture_in_picture.svg';
import { PipStyled } from './styles/PipStyled';

const Pip = ({ onClick, isPipModeOn }) => {
  const iconName = isPipModeOn ? picture_in_picture_alt.id : picture_in_picture.id;
  return <PipStyled icon={iconName} iconSize={26} onClick={onClick} />;
};

export default memo(Pip);
